module.exports = __webpack_public_path__ + "img/9788958092698.25e00466.jpg";